<template>
  <div id="listWidget" class="mb-5">
    <InstructionStepsCard
      title="WiFi 변경 단계"
      :steps="wifiChangeSteps"
    />

    <SettingWarningBox
      message="등록 전에 와이파이만 연결하거나, 기존 조명제어기의 와이파이를 바꿀 때 사용하십시오."
    />

    <ControllerModelGuideCard />

    <!-- 연결 버튼 -->
    <div class="action-button-container mb-3" v-if="wizardStep === 1">
      <button
        type="button"
        class="btn btn-primary w-100"
        @click="connectionDialog.show"
      >
        <i class="fa-solid fa-link me-2"></i>
        연결
      </button>
    </div>

    <!-- 완료 단계 -->
    <WizardSetWifiCompleteStep
      v-if="wizardStep === 3"
      :step="wizardStep"
      :controller="connectedController"
    />

    <!-- ControllerConnectionDialog -->
    <ControllerConnectionDialog
      :visible="connectionDialog.visible"
      title="조명제어기 연결 및 WiFi 설정"
      actionType="wifi-change"
      :needsProvisioning="true"
      :needsWifiInput="true"
      :initialWifiSsid="settingParams.ssid"
      :initialWifiPassword="settingParams.pwd"
      @complete="onConnectionComplete"
      @cancel="connectionDialog.hide"
    />
  </div>

  <div id="footer" class="app-footer ms-0">
    <footer class="mt-auto">
      <div class="row">
        <div class="col" />
        <div class="col" />
        <div class="col">
          <button
            v-if="wizardStep === 3"
            type="button"
            class="btn btn-primary btn-lg"
            style="width: 100%"
            @click="onComplete"
          >
            완료
          </button>
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { ref, getCurrentInstance, reactive, onBeforeMount, onBeforeUnmount } from 'vue';
import useMobile from '@/common/hooks/useMobile';   
import { useRouter } from 'vue-router';
import WizardSetWifiCompleteStep from './components/wizard/WizardSetWifiCompleteStep';
import ControllerConnectionDialog from './components/ControllerConnectionDialog.vue';
import InstructionStepsCard from './components/InstructionStepsCard.vue';
import SettingWarningBox from './components/SettingWarningBox.vue';
import ControllerModelGuideCard from './components/ControllerModelGuideCard.vue';
import useModal from '@/common/hooks/useModal';

const wifiChangeSteps = [
  '조명제어기의 <strong>리셋(RESET) 버튼</strong>을 길게 눌러서 세팅 모드로 진입하시고 LED를 확인하십시오.',
  '<strong>연결 버튼</strong>을 눌러서 조명제어기에 접속하십시오.',
  '로컬 WiFi 정보를 설정해주십시오.',
];

const router = useRouter();
const { emitter } = getCurrentInstance().appContext.config.globalProperties;

// 팝업 상태 관리
const connectionDialog = reactive(useModal());

// 설정 파라미터
const settingParams = ref({
  ssid: '',
  pwd: '',
  firmware_version: '',
  firmware_url: '',
  uuid: '',
  device_key: '',
  mqtt_url: process.env.VUE_APP_CTRL_MQTT_DOMAIN,
  mqtt_username: '',
  mqtt_password: '',
});

// 연결된 컨트롤러 정보
const connectedController = ref({
  _id: '',
  version: '',
  model: '',
});

// Wizard 단계
const wizardStep = ref(1);
onBeforeMount(() => {
  emitter.emit('onChangeHeaderSetting',{title:'조명제어기 WiFi 설정',isShowMenu:false,isShowZone:false,isShowProfile:false,isShowRightHome:true});    
});
onBeforeUnmount(() => {
  emitter.emit('onChangeHeaderSetting',{title:'',isShowMenu:true,isShowZone:true,isShowProfile:true,isShowRightHome:false});  
});
// 연결 완료 핸들러
const onConnectionComplete = async (result) => {
  const { controller, connectionType, wifiSsid, wifiPassword } = result;
  
  // 연결된 컨트롤러 정보 저장
  connectedController.value = controller;
  
  // WiFi 설정 정보 저장
  settingParams.value.ssid = wifiSsid;
  settingParams.value.pwd = wifiPassword;
  
  // 완료 단계로 이동
  wizardStep.value = 3;
  
  // 팝업 닫기
  connectionDialog.hide();
};


// 완료 버튼 클릭 핸들러
const onComplete = () => {
  router.go(-1);
};
</script>

<style scoped>
.action-button-container {
  margin-top: 0;
}

.action-button-container .btn {
  padding: 0.625rem 1rem;
  font-size: 0.9rem;
  font-weight: 500;
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.action-button-container .btn:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}
</style>
